<template>
    <div class="detail">
        <div class="image-resort">
            <img :src="resort.photo != '' ? resort.photo : '@/assets/img/img-placeholder-horizontal.png'" />
        </div>
        <div class="divide-y divide-grey-border">
            <div v-if="selectedProduct" class="summary-section-resume">
                <product-resume />
                <separator />
            </div>
            <div v-if="selectedProduct" class="summary-section">
                <div class="title-section">{{ $t("details.forfait.title") }}</div>
                <div class="description">{{ translate(selectedProduct, 'name') }}</div>
                <div v-if="details.length > 0 && selectedProduct.requirements.date" class="description">
                    {{ details[0].date | longDate }}
                </div>
            </div>
            <div v-if="people.length > 0" class="summary-section">
                <div class="title-section">{{ $t("people.people") }}</div>
                <div v-for="(participant, i) in people" :key="i"  class="description">
                    {{ participant.total }} {{ participant.type }}
                </div>
            </div>
            <div v-if="people.length > 0">
                <cart-summary />
            </div>
        </div>
        <div class="links">
            <info-box>
                <div class="block">
                    <p v-for="(page, i) in resort.pages" :key="i" @click="openModal(page)" class="mb-2">
                        {{ translate(page, 'name') }}
                    </p>
                </div>
            </info-box>
            <modal :closeButtonText="i18n.t('review.ok')" @close="closeModal" v-if="showModal">
                <div slot="title">
                    <span>{{ modal.name }}</span>
                </div>
                <div slot="body">
                    <span>{{ modal.description }}</span>
                </div>
            </modal>
        </div>
        
    </div>
</template>

<script>
    import Modal from "@/components/common/modal";
    import InfoBox from "@/components/common/info-box";
    import Separator from "@/components/common/separator";
    import CartSummary from '@/components/common/cart-summary'
    import ProductResume from "@/views/participants/components/product-resume";
    import { translate } from '@/helpers/translationsHelpers.js'
    import { mapGetters } from "vuex";
    import i18n from '@/i18n';

    export default {
        name: "DetailForfait",
        components: {
            Modal,
            InfoBox,
            Separator,
            CartSummary,
            ProductResume
        },
        data() {
            return {
                i18n: i18n,
                showModal: false,
                modal: {
                    name: '',
                    description: ''
                },
            };
        },
        computed: {
            ...mapGetters("resort", ["resort", "selectedProduct", "participantById"]),
            ...mapGetters("order", ["details"]),
            people() {
                return Object.values(this.details.reduce((carry, participant) => {
                    if (carry[participant.participant_id]) {
                        carry[participant.participant_id].total++
                    } else {
                        const participantType = translate(this.participantById(participant.participant_id), 'name')
                        carry[participant.participant_id] = { type: participantType, total: 1 }
                    }
                    return carry
                }, {}))
            }
        },
        methods: {
            openModal: function(page) {
                this.modal = this.translate(page)
                this.showModal = true
            },
            closeModal: function() {
                this.showModal = false
            },
            translate(object, field) {
                return translate(object, field)
            }
        }
    }
</script>

<style scoped>
    .detail {
        @apply bg-white h-auto;
    }

    .image-resort {
        @apply hidden;
    }

    .summary-section {
        @apply px-5 py-6 hidden;
    }

    .summary-section .title-section {
        @apply font-medium mb-2.5;
    }

    .summary-section .description {
        @apply text-grey-text;
    }

    .summary-section-resume {
        @apply block;
    }

    .links {
        @apply block;
    }

    .links p {
        @apply underline cursor-pointer;
    }

    @screen lg {
        .image-resort {
            @apply relative block;
        }

        .resort-title {
            bottom: 15px;
            left: 15px;
            @apply absolute text-white font-bold text-xl;
        }

        .summary-section {
            @apply block;
        }

        .summary-section-resume {
            @apply hidden;
        }

        .links {
            @apply hidden;
        }
    }
</style>